import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../../contexts/halfYearContext";

import Table from "../../../common/Table";

import db from "../../../../services/query";
import Option from "../../../common/RowOption";

const AccountsReport = () => {
  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "حساب" },
    { path: "fee_received", label: "فیس" },
    { path: "revenue_received", label: "سایر درآمدها" },
    { path: "debt_paid", label: "بدهی" },
    { path: "expense_paid", label: "مصارف" },
    { path: "teacher_salary_paid", label: "معاشات استادان" },
    { path: "staff_salary_paid", label: "معاشات کارمندان" },
    { path: "total_received", label: "مجموع دریافت" },
    { path: "total_paid", label: "مجموع پرداخت" },
    { path: "balance", label: "باقیمانده" },
    { path: "option",
      content: (e) => <Option printStatement={e}  />
    },
  ];

  const [data, setData] = useState([]);
  const { halfYear } = useContext(HalfYearContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `accounts?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  console.log(data);
  return <Table data={data} columns={columns} />;
};

export default AccountsReport;
